import React from 'react';
import { Eyebrow } from './Primitives';

/**
 * Full-bleed page header. The site bar is fixed and transparent at the top of
 * a page, so the image runs underneath it and the content is padded clear.
 */
const PageBanner = ({ image, kicker, title, lead, children }) => (
  <section className="relative bg-ink overflow-hidden">
    {image && (
      <>
        <img
          src={image}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* Dark enough at the top for the nav to sit on, settling into the
            page ground at the bottom edge. */}
        <div
          aria-hidden="true"
          className="absolute inset-0 bg-gradient-to-b from-ink/85 via-ink/70 to-ink/95"
        />
      </>
    )}
    <div className="relative container mx-auto px-5 md:px-8 pt-32 pb-16 md:pt-40 md:pb-20">
      <div className="max-w-3xl">
        {kicker && <Eyebrow tone="dark">{kicker}</Eyebrow>}
        <h1 className="mt-4 font-display font-semibold text-paper text-[2.5rem] leading-[1.08] md:text-[3.75rem]">
          {title}
        </h1>
        {lead && (
          <p className="mt-6 text-paper/70 text-lg leading-relaxed max-w-2xl">{lead}</p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </div>
  </section>
);

export default PageBanner;
